// extracted by mini-css-extract-plugin
export default {"main":"Home_main__1dyei","isPrivate":"Home_isPrivate__1twzG","container":"Home_container__2OUkf","message":"Home_message__2AcLm","onlyMobile":"Home_onlyMobile__2pOKX","onlyDesktop":"Home_onlyDesktop__1gnLB"};
    if(module.hot) {
      // 1741870133747
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  